const HiscoxSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            data-testid="hiscox"
            className={className}
            x="0px"
            y="0px"
            viewBox="0 0 127.5 137.3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="st0"
                d="M63.8,122.6c3.6-35.1,22.6-55.9,22.6-76.2c0-14.7-5.5-27.3-22.6-46.4C46.6,19,41.2,31.6,41.2,46.4
	C41,66.6,60.2,87.4,63.8,122.6z M26.7,118.1C17.6,126.1,0,121,0,101.6c0-10.9,11.4-20.3,22.4-20.3c21.8,0,31.7,23.2,32.3,33.9
	c0.4,8.5-3.4,21.9-17.5,22.1c6.6-3.3,8.9-11.2,8.2-16.9c-0.7-6.7-5.1-15.5-14.5-15.5c-5.2,0-9.2,3.4-9.2,7
	C21.6,115.2,23.6,118,26.7,118.1L26.7,118.1z M100.8,118.1c9.1,8,26.7,2.9,26.7-16.5c0-10.9-11.4-20.3-22.4-20.3
	c-21.8,0-31.7,23.2-32.3,33.9c-0.4,8.5,3.4,21.9,17.5,22.1c-6.6-3.3-8.9-11.2-8.2-16.9c0.7-6.7,5.1-15.5,14.5-15.5
	c5.2,0,9.2,3.4,9.2,7C105.8,115.2,103.8,118,100.8,118.1L100.8,118.1z"
            ></path>
        </svg>
    );
};

// eslint-disable-next-line import/no-default-export
export default HiscoxSVG;
